import request from '@/utils/request'

let IndexApi = {

  /*基础配置*/
  base(data) {
    return request._get('/api/open/base', data);
  },

  /*智联车途企业工作台真实统计*/
  workbench(data) {
    return request._post('/shop/Index/workbench', data);
  },

  /*原有首页接口：保留兼容*/
  getCount(data) {
    return request._post('/shop/Index/index', data);
  },
   /*原有统计接口：保留兼容*/
  getCounts(data) {
    return request._post('/shop/Index/indexs', data);
  },


}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js